const cardsSupport  = {
    "cardHeading": "Support article links",
    "cardsAdditional": [
      {
        "title": "Accessibility for all",
        "icon": "Accessibility",
        "link": "https://www.xfinity.com/support/accessibility",
        "linkText": "Get accessibility support",
        "description": "Find out about closed captioning, voice guidance, and other features for users with disabilities."
      },
      {
        "title": "Get account and billing help",
        "icon": "Account",
        "link": "https://www.xfinity.com/support/account-billing",
        "linkText": "View account & billing support",
        "description": "Learn about your bill, how to enroll in automatic payments, and ways to manage your services."
      },
      {
        "title": "Having service issues?",
        "icon": "StatusCenter",
        "link": "https://www.xfinity.com/support/status",
        "linkText": "Access the status center",
        "description": "Check for service outages that could be affecting you, and troubleshoot solutions."
      },
      {
        "title": "Move in a minute",
        "icon": "Move",
        "link": " https://www.xfinity.com/moves",
        "linkText": "Schedule a move",
        "description": "Prepare for your upcoming move online and stay connected to fast WiFi, TV, and more."
      },
      {
        "title": "Get help in person",
        "icon": "LocateStore",
        "link": "https://www.xfinity.com/support/service-center-locations",
        "linkText": "Locate a store",
        "description": "Find an Xfinity store or service center near you."
      }
    ]
}

export default cardsSupport;